import Vue from "vue"; // 引入 Vue 是因为要用到 Vue.extend() 这个方法
import loading from "./loading.vue"; // 引入刚才的 toast 组件

let LoadingConstructor = Vue.extend(loading); // 这个在前面的前置知识内容里面有讲到
let instance;

function merge (target) {
    for (let i = 1, j = arguments.length; i < j; i++) {
      let source = arguments[i] || {};
      for (let prop in source) {
        if (source.hasOwnProperty(prop)) {
          let value = source[prop];
          if (value !== undefined) {
            target[prop] = value;
          }
        }
      }
    }
    return target;
};

const defaults = {
    base_showLoading:false,
    base_title:"loading",
    base_status:"loading",
    base_failedTxt:"操作失败",
    base_duration: 3000,
    propsFlag:false,
}
console.log(LoadingConstructor)
LoadingConstructor.prototype.close = function() {
    if (this.showLoading) {
        this.showLoading = false;
    }
}
const Loading = function (options = {}) {
    options = merge({}, defaults, options);
    instance = new LoadingConstructor(
        {
            data:options
        }
    ).$mount(); // 渲染组件
    console.log(instance)
    document.body.appendChild(instance.$el); // 挂载到 body 下
};
// console.log(Loading)
export default Loading;
